/* eslint-disable camelcase */
/**
 * 以下是跟天机ST定义的通讯协议组包及解包
 * 协议负责人 davinliu
 * @author gabewu
 */

import { _log } from './utils/log';
import msgId from './utils/uuid';
function optionalChain(obj, props) {
  return props.reduce((acc, prop) => (acc && acc[prop]) ? acc[prop] : null, obj);
}

/**
 * 返回一个 proto实例
 */
function createProto() {
   
  /**
   * 1. 消息发送请求包
   * http://9.135.87.124/#api-cloudim-324015
   */
  function createMsgSendReq(term, from, to, elems, config, crmData) {
    return {
      msg_send_req: {
        msg_send_msg: {
          msg_package_head: {
            uint32_pkg_num: 1,
            uint32_pkg_index: 0,
            uint32_div_seq: 1,
          },
          msg_msg_head: createMsgSendHead(term, from, to, 0, config, crmData),
          msg_msg_body: createMsgSendBody(elems),
        },
      },
    };
  }

  function createMsgSendHead(term, from, to, uint32_type, config, crmData = {}) {
    const uuid = createMessageUUID();
    let { crm_user_type } = to;

    if (crm_user_type === proto.config.channelType) {
      /**
           * 前端对于webim的定义是4
           * svr对于webim的定义是3
           */
      // 私有化：当为4时不处理
      // crm_user_type = 3;
    } else if (crm_user_type === 2) {
      /**
           * 前端对于微信公众号的定义是2
           * svr对于微信公众号的定义是1
           */
      crm_user_type = 1;
    } else if (crm_user_type === 6) {
      /**
          * 前端对于微信小程序的定义是6
          * svr对于微信小程序的定义是11
          */
      crm_user_type = 11;
    }
    return {
      uint32_type: uint32_type || 0, // 消息类型 0:C2C,1:群组,2:通知
      uint64_random: uuid, // 消息发送随机值,svr在回包中带回此值确认消息发送成功
      uint64_msg_time: Date.now(), // 消息发送时间,svr在回包中校正时间返回
      uint32_from_term: term, // 消息业务类型 5:web工作台
      uint32_client_ip: 0,
      msg_type_info: {
        msg_c2c_info: {
          uint64_from_aid: from, // 消息发送方
          uint64_to_aid: to.aid, // 消息接收方
        },
      },
      msg_app_info: {
        uint32_to_aid_type: 1, // 接收方账号类型 0:普通C侧用户 1:公众号(客服号)
        uint32_from_aid_type: 0, // 发送方账号类型 0:普通C侧用户 1:公众号(客服号)
      },
      msg_third_app_info: {
        bytes_third_app_buf: {
          bytes_crm_buf: {
            crm_user_type,
            str_cid: to.str_cid,
            str_visitId: to.str_cid,
            str_session_id: to.str_session_id,
            uint64_pubacc_id: to.uint64_pubacc_id,
            uint32_msg_id: to.uint32_msg_id || 0,
            msg_attributes_info: {
              str_qidian_msg_unique_id: createQidianMsgUniqueId(from, to.aid)
            },
            str_current_qidian_msg_unique_id: msgId(),
            ...crmData,
            msg_webim_extra_data: { // webim额外信息
              bytes_wpaid: config.wpaId,
            },
          },
        },
      },
    };
  }

  function createMsgSendBody(elems) {
    return {
      rich_text: {
        elems,
      },
    };
  }

  function createCrmbufMsgSendReq(term, from, to, crmbuf, config) {
    return {
      msg_send_req: {
        msg_send_msg: {
          msg_package_head: {
            uint32_pkg_num: 1,
            uint32_pkg_index: 0,
            uint32_div_seq: 1,
          },
          msg_msg_head: createCrmbufMsgSendHead(term, from, to, crmbuf, config),
          msg_msg_body: null,
        },
      },
    };
  }

  function createCrmbufMsgSendHead(term, from, to, crmbuf, config) {
    const uuid = createMessageUUID();
    let { crm_user_type } = to;

    if (crm_user_type === config.channelType) {
      /**
           * 前端对于webim的定义是4
           * svr对于webim的定义是3
           */
      // 私有化：当为4时不处理
      // crm_user_type = 3;
    } else if (crm_user_type === 2) {
      /**
           * 前端对于微信公众号的定义是2
           * svr对于微信公众号的定义是1
           */
      crm_user_type = 1;
    } else if (crm_user_type === 6) {
      /**
          * 前端对于微信小程序的定义是6
          * svr对于微信小程序的定义是11
          */
      crm_user_type = 11;
    }
    return {
      uint32_type: 0, // 消息类型 0:C2C,1:群组,2:通知
      uint64_random: uuid, // 消息发送随机值,svr在回包中带回此值确认消息发送成功
      uint64_msg_time: Date.now(), // 消息发送时间,svr在回包中校正时间返回
      uint32_from_term: term, // 消息业务类型 5:web工作台
      uint32_client_ip: 0,
      msg_type_info: {
        msg_c2c_info: {
          uint64_from_aid: from, // 消息发送方
          uint64_to_aid: to.aid, // 消息接收方
        },
      },
      msg_app_info: {
        uint32_to_aid_type: 1, // 接收方账号类型 0:普通C侧用户 1:公众号(客服号)
        uint32_from_aid_type: 0, // 发送方账号类型 0:普通C侧用户 1:公众号(客服号)
      },
      msg_third_app_info: {
        bytes_third_app_buf: {
          bytes_crm_buf: {
            crm_user_type,
            str_cid: to.str_cid,
            str_visitId: to.str_cid,
            str_session_id: to.str_session_id,
            uint64_pubacc_id: to.uint64_pubacc_id,
            uint32_msg_id: to.uint32_msg_id || 0,
            msg_attributes_info: {
              str_qidian_msg_unique_id: createQidianMsgUniqueId(from, to.aid)
            },
            str_current_qidian_msg_unique_id: msgId(),
            ...crmbuf,
            msg_webim_extra_data: { // webim额外信息
              bytes_wpaid: config.wpaId,
            },
          },
        },
      },
    };
  }
  /**
   * 2. 消息发送响应包
   * http://9.135.87.124/#api-cloudim-324015
   */
  function unpackMsgSendRsp(response) {
    const { msg_ret_info } = response;
    if (msg_ret_info && msg_ret_info.uint32_ret_code !== 0) {
      // 由于敏感词拦截等原因导致发送失败
      return {
        code: msg_ret_info.uint32_ret_code,
        error: msg_ret_info.str_error_msg,
      };
    }

    const { msg_send_rsp } = response;
    const { msg_send_msg } = msg_send_rsp;
    // const msg_package_head = msg_send_msg["msg_package_head"]; // 目前不用
    const { msg_msg_head } = msg_send_msg;

    const { uint64_random } = msg_msg_head; // 发送消息uuid
    const { uint64_msg_sync_seq } = msg_msg_head;
    const { uint64_msg_roaming_seq } = msg_msg_head;
    const { uint64_msg_time } = msg_msg_head; // svr校正返回的时间

    const msg_third_app_info = msg_msg_head.msg_third_app_info || { bytes_third_app_buf: { bytes_crm_buf: '' } };
    const { bytes_third_app_buf } = msg_third_app_info;
    const { bytes_crm_buf } = bytes_third_app_buf;

    const { msg_type_info } = msg_msg_head;
    const { msg_c2c_info } = msg_type_info;
    const { uint64_from_aid } = msg_c2c_info; // 消息发送方
    const { uint64_to_aid } = msg_c2c_info; // 消息接受方

    const msg_msg_body = msg_send_msg.msg_msg_body || { rich_text: '', revoke_message: '' };
    const { revoke_message } = msg_msg_body;
    const { rich_text } = msg_msg_body;
    const result = [];
    if (rich_text && !(bytes_crm_buf && bytes_crm_buf.crm_flag === 55)) {
      // 为了完成这个需求做的特殊策略https://iwiki.woa.com/pages/viewpage.action?pageId=4007964350
      // 但crm_flag为55时，强制忽略rich_text中的值。
      // 这是因为rich_text存放的是给其他通路使用的数据，webim和小程序插件使用crm中的值。
      const elems = rich_text.elems || [];
      const array = [];
      for (const elem of elems) {
        if (!elem) continue;
        if (elem.text) {
          array.push({
            type: 'text',
            content: elem.text.str,
          });
        } else if (elem.face) {
          array.push({
            type: 'face',
          });
        } else if (elem.media_resources) {
          array.push({
            type: 'media_resources',
          });
        } else if (elem.image) {
          array.push({
            type: 'image',
          });
        } else if (elem.long_msg) {
          array.push({
            type: 'long_msg',
          });
        } else if (elem.structured_info) {
          const sinfo = elem.structured_info;
          if (sinfo.uint32_format_flag === 1) { // 通用结构化消息，同 flag=14的情况
            array.push({
              type: 'qdxml_msg',
            });
          } else if (sinfo.uint32_format_flag === 2) {
            array.push({
              type: 'image_text',
            });
          } else {
            _log('structured_info uint32_format_flag error!', sinfo.uint32_format_flag);
          }
        } else if (elem.file_info) {
          array.push({
            type: 'file_info',
          });
        } else if (elem.ptt_info) {
          array.push({
            type: 'ptt_info',
          });
        } else {
          array.push({
            type: 'text',
            content: '[未知消息类型]',
          });
        }
      }
      if (array.length === 1) {
        result.push({
          ...array[0],
        });
      } else if (array.length > 1) {
        result.push({
          type: 'mix',
          content: array,
        });
      }
    } else if (revoke_message) {
      result.push({
        type: 'revoke_msg',
        content: {
          seq: revoke_message.uint64_msg_roaming_seq,
          syncseq: revoke_message.uint64_msg_sync_seq,
          sidesyncseq: revoke_message.uint64_side_sync_seq,
          time: revoke_message.uint64_msg_time / 1000,
        },
      });
    } else {
      if (bytes_crm_buf && bytes_crm_buf.crm_flag) {
        const {
          crm_flag: crmFlag,
          template_message: templateMsg,
          msg_common_control_msg_info: commonInfo,
          msg_third_party_msg_info: thirdInfo
        } = bytes_crm_buf;

        if (crmFlag === 14 && commonInfo) {
          result.push({
            type: 'qdxml_msg',
          });
        } else if (crmFlag === 55 && templateMsg) {
          result.push({
            type: 'robot',
          });
        } else if (crmFlag === 115 && commonInfo) {
          // 机器人导航
          result.push({
            type: 'robot_nav',
          });
        } else if (crmFlag === 56 && commonInfo) {
          // sdk-机器人消息，先和普通机器人消息（crm_flag=55）一样处理
          result.push({
            type: 'robot',
          });
        } else if (thirdInfo && crmFlag) {
          // 统一归入第三方消息
          result.push({
            type: 'third_msg',
          });
        }
      }
    }

    return {
      str_qidian_msg_unique_id: optionalChain(bytes_crm_buf, ['msg_attributes_info', 'str_qidian_msg_unique_id']),
      uuid: uint64_random,
      seq: uint64_msg_roaming_seq,
      syncseq: uint64_msg_sync_seq,
      time: uint64_msg_time / 1000,
      from: uint64_from_aid,
      to: uint64_to_aid,
      content: result,
    };
  }

  /**
   * 3. 新消息推送通知包
   * com.tencent.qidian.cloudim.sc.CMD0x431
   * 收到消息推送后要主动向svr拉取实时消息
   */
  function unpackNewMsgNotice(response) {
    const { push_new_message_notice } = response;
    const { uint64_msg_sync_seq } = push_new_message_notice; // 拉取的消息seq
    return uint64_msg_sync_seq;
  }

  /**
   * 4. 同步消息请求包
   * http://9.135.87.124/#api-cloudim-324016
   */
  function createMsgSyncReq(aid, seq, size) {
    return {
      msg_sync_req: {
        uint64_sync_aid: aid, // 消息发送方
        uint64_sync_seq: seq, // 消息seq
        uint32_sync_size: size, // 消息拉取的条数
      },
    };
  }

  /**
   * 5. 同步消息响应包
   * http://9.135.87.124/#api-cloudim-324016
   */
  function unpackMsgSyncRsp(response) {
    const result = [];
    const msg_sync_rsp = response.msg_sync_rsp || { rpt_msg_sync_msg: [] };
    const rpt_msg_sync_msg_array = msg_sync_rsp.rpt_msg_sync_msg || [];
    for (const rpt_msg_sync_msg of rpt_msg_sync_msg_array) {
      if (!rpt_msg_sync_msg) {
        continue;
      }
      // const msg_package_head = rpt_msg_sync_msg["msg_package_head"]; // 目前不用
      const { msg_msg_head } = rpt_msg_sync_msg;

      // const { uint64_random } = msg_msg_head; // 发送消息uuid
      const { uint64_msg_sync_seq } = msg_msg_head; // 同步消息seq
      const { uint64_msg_roaming_seq } = msg_msg_head; // 漫游消息seq
      const { uint64_msg_time } = msg_msg_head; // svr校正返回的时间

      const msg_third_app_info = msg_msg_head.msg_third_app_info || { bytes_third_app_buf: { bytes_crm_buf: '' } };
      const { bytes_third_app_buf } = msg_third_app_info;
      const { bytes_crm_buf } = bytes_third_app_buf;
      if (bytes_crm_buf) {
        if (bytes_crm_buf.crm_user_type === 3) {
          /**
                   * svr对于webim的定义是3
                   * 前端对于webim的定义是4
                   */
          bytes_crm_buf.str_cid = bytes_crm_buf.str_visitId;
          bytes_crm_buf.crm_user_type = proto.config.channelType;
        } else if (bytes_crm_buf.crm_user_type === 1) {
          /**
                   * svr对于微信公众号的定义是1
                   * 前端对于微信公众号的定义是2
                   */
          bytes_crm_buf.str_cid = `${bytes_crm_buf.str_qidian_third_app_appid}_${bytes_crm_buf.str_wx_openid}`;
          bytes_crm_buf.crm_user_type = 2;
        } else if (bytes_crm_buf.crm_user_type === 11) {
          /**
                   * svr对于微信小程序的定义是11
                   * 前端对于微信小程序的定义是6
                   */
          bytes_crm_buf.str_cid = `${bytes_crm_buf.str_qidian_third_app_appid}_${bytes_crm_buf.str_wx_openid}`;
          bytes_crm_buf.crm_user_type = 6;
        }
      }

      const { msg_type_info } = msg_msg_head;
      const { msg_c2c_info } = msg_type_info;
      const { uint64_from_aid } = msg_c2c_info; // 消息发送方
      const { uint64_to_aid } = msg_c2c_info; // 消息接受方

      const msg_msg_body = rpt_msg_sync_msg.msg_msg_body || { rich_text: '', revoke_message: '' };
      const { revoke_message } = msg_msg_body;
      const { rich_text } = msg_msg_body;
      if (bytes_crm_buf && bytes_crm_buf['msg_common_audio_video']) {
        // webRTC实时音视频消息
        let rtc_msg = unpackMsgRTCMsg(bytes_crm_buf['msg_common_audio_video']);
        result.push({
            type: 'rtc_msg',
            seq: uint64_msg_roaming_seq,
            syncseq: uint64_msg_sync_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            content: rtc_msg,
            crm: bytes_crm_buf
        })
      } else if (rich_text && !(bytes_crm_buf && bytes_crm_buf.crm_flag === 55)) {
        // 为了完成这个需求做的特殊策略https://iwiki.woa.com/pages/viewpage.action?pageId=4007964350
        // 但crm_flag为55时，强制忽略rich_text中的值。
        // 这是因为rich_text存放的是给其他通路使用的数据，webim和小程序插件使用crm中的值。
        const elems = rich_text.elems || [];
        const array = [];
        for (const elem of elems) {
          if (!elem) continue;
          if (elem.text) {
            array.push({
              type: 'text',
              content: elem.text.str,
            });
          } else if (elem.face) {
            array.push({
              type: 'face',
              index: elem.face.uint32_index, // 表情索引号
              content: elem.face.bytes_default_text || '[自定义表情]',
            });
          } else if (elem.media_resources) {
            array.push({
              type: 'media_resources',
              meida_type: elem.media_resources.int32_meida_type,
              media_url: elem.media_resources.bytes_media_url,
              content: elem.media_resources.bytes_media_url,
            });
          } else if (elem.image) {
            array.push({
              type: 'image',
              uuid: elem.image.bytes_uuid,
              content: elem.image.bytes_image_path,
              md5: elem.image.bytes_image_md5,
              name: elem.image.bytes_image_name,
              size: elem.image.uint32_image_size,
              width: elem.image.uint32_image_width,
              height: elem.image.uint32_image_height,
              format: elem.image.uint32_image_format,
              resStore: elem.image.uint32_res_store,
              cosBucket: elem.image.uint32_cos_bucket,
            });
          } else if (elem.long_msg) {
            array.push({
              type: 'long_msg',
              content: elem.long_msg.bytes_longmsg_path,
              uuid: elem.long_msg.bytes_uuid,
              resStore: elem.long_msg.uint32_res_store,
              compressed: elem.long_msg.uint32_compress_type,
              cosBucket: elem.long_msg.uint32_cos_bucket,
            });
          } else if (elem.structured_info) {
            const sinfo = elem.structured_info;
            if (sinfo.uint32_format_flag === 1) { // 通用结构化消息，同 flag=14的情况
              array.push({
                type: 'qdxml_msg',
                content: {
                  uuid: sinfo.bytes_uuid,
                  path: sinfo.bytes_structure_path,
                  brief: sinfo.str_msg_brief,
                  content: sinfo.bytes_structure_content,
                  resStore: sinfo.uint32_res_store,
                  compressed: sinfo.uint32_structure_compress_type,
                  cosBucket: sinfo.uint32_cos_bucket,
                }
              });
            } else if (sinfo.uint32_format_flag === 2) {
              array.push({
                type: 'image_text',
                uuid: sinfo.bytes_uuid,
                path: sinfo.bytes_structure_path,
                content: sinfo.bytes_structure_content,
                format: sinfo.uint32_format_flag,
                resStore: sinfo.uint32_res_store,
                compressed: sinfo.uint32_structure_compress_type,
                cosBucket: sinfo.uint32_cos_bucket,
              });
            } else {
              _log('structured_info uint32_format_flag error!', sinfo.uint32_format_flag);
            }
          } else if (elem.file_info) {
            array.push({
              type: 'file_info',
              uuid: elem.file_info.bytes_uuid,
              content: elem.file_info.bytes_file_path,
              md5: elem.file_info.bytes_file_md5,
              name: elem.file_info.bytes_file_name,
              size: elem.file_info.uint32_file_size,
              format: elem.file_info.bytes_file_format,
              cosBucket: elem.file_info.uint32_cos_bucket,
            });
          } else if (elem.ptt_info) {
            array.push({
              type: 'ptt_info',
              uuid: elem.ptt_info.bytes_uuid,
              content: elem.ptt_info.bytes_ptt_path,
              md5: elem.ptt_info.bytes_ptt_md5,
              length: elem.ptt_info.uint32_ptt_length,
              size: elem.ptt_info.uint32_ptt_size,
              format: elem.ptt_info.uint32_format,
              cosBucket: elem.ptt_info.uint32_cos_bucket,
            });
          } else {
            array.push({
              type: 'text',
              content: '[未知消息类型]',
            });
          }
        }
        if (array.length === 1) {
          result.push({
            seq: uint64_msg_roaming_seq,
            syncseq: uint64_msg_sync_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            crm: bytes_crm_buf,
            ...array[0],
            msgHead: msg_msg_head,
            msgBody: msg_msg_body,
          });
        } else if (array.length > 1) {
          result.push({
            type: 'mix',
            seq: uint64_msg_roaming_seq,
            syncseq: uint64_msg_sync_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            crm: bytes_crm_buf,
            content: array,
            msgHead: msg_msg_head,
            msgBody: msg_msg_body,
          });
        }
      } else if (revoke_message) {
        result.push({
          type: 'revoke_msg',
          // seq: uint64_msg_roaming_seq,
          seq: revoke_message.uint64_msg_roaming_seq,
          syncseq: uint64_msg_sync_seq,
          // sidesyncseq: revoke_message["uint64_side_sync_seq"],
          time: uint64_msg_time / 1000,
          from: uint64_from_aid,
          to: uint64_to_aid,
          content: revoke_message.uint64_msg_roaming_seq,
          crm: bytes_crm_buf,
          msgHead: msg_msg_head,
          msgBody: msg_msg_body,
        });
      } else {
        if (bytes_crm_buf && bytes_crm_buf.crm_flag) {
          const {
            crm_flag: crmFlag,
            template_message: templateMsg,
            msg_common_control_msg_info: commonInfo,
            msg_third_party_msg_info: thirdInfo
          } = bytes_crm_buf;

          if (crmFlag === 14 && commonInfo) {
            let content = {
              path: commonInfo.str_control_msg_resid,
              brief: commonInfo.str_msg_brief,
              content: commonInfo.bytes_structure_content,
              resStore: commonInfo.uint32_res_store,
              compressed: commonInfo.uint32_structure_compress_type,
              cosBucket: commonInfo.uint32_cos_bucket,
            };

            result.push({
              type: 'qdxml_msg',
              seq: uint64_msg_roaming_seq,
              syncseq: uint64_msg_sync_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content,
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 55 && templateMsg) {
            // 机器人html消息
            const { bytes_content, uint32_type } = templateMsg;
            result.push({
              // 13为特殊类型的机器人表单消息
              type: uint32_type === 13 ? 'robot_form' : 'robot',
              seq: uint64_msg_roaming_seq,
              syncseq: uint64_msg_sync_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: JSON.parse(bytes_content),
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 115 && commonInfo) {
            // 机器人导航
            result.push({
              type: 'robot_nav',
              seq: uint64_msg_roaming_seq,
              syncseq: uint64_msg_sync_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: {
                path: commonInfo.str_control_msg_resid,
                content: commonInfo.bytes_structure_content,
                resStore: commonInfo.uint32_res_store,
                compressed: commonInfo.uint32_structure_compress_type,
                cosBucket: commonInfo.uint32_cos_bucket,
              },
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 56 && commonInfo) {
            // sdk-机器人消息，先和普通机器人消息（crm_flag=55）一样处理
            const { bytes_structure_content, uint32_type } = commonInfo;
            result.push({
              // 13为特殊类型的机器人表单消息
              type: uint32_type === 13 ? 'robot_form' : 'robot',
              seq: uint64_msg_roaming_seq,
              syncseq: uint64_msg_sync_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: JSON.parse(bytes_structure_content),
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 11) {
            const gray_msg = unpackMsgGrayMsg(bytes_crm_buf);
            result.push({
              type: 'gray_msg',
              seq: uint64_msg_roaming_seq,
              syncseq: uint64_msg_sync_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: gray_msg,
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (thirdInfo && crmFlag) {
            // 未命中其他规则，则统一处理为 third_msg
            result.push({
              type: 'third_msg',
              seq: uint64_msg_roaming_seq,
              syncseq: uint64_msg_sync_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: {
                crmFlag,
                path: thirdInfo.string_res_id,
                brief: thirdInfo.string_msg_brief,
                content: thirdInfo.string_msg_content,
                resStore: thirdInfo.uint32_res_store,
              },
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          }
        } else {
          // 兜底消息
          result.push({
            seq: uint64_msg_roaming_seq,
            syncseq: uint64_msg_sync_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            content: null,
          });
        }
      }
    }

    return result;
  }

  /**
   * 6. 漫游消息请求包
   * http://9.135.87.124/#api-cloudim-324017
   */
  function createMsgRoamingReq(from, to, seq, size) {
    return {
      msg_roaming_req: {
        uint32_roaming_type: 1, // 漫游类型 1:seq拉取 2:限制时间段消息
        uint32_type: 0, // 消息类型 0:C2C 1:群组 2:通知类消息
        msg_type_info: {
          msg_c2c_info: {
            uint64_from_aid: from, // 发送方
            uint64_to_aid: to, // 接收方
          },
        },
        msg_roaming_seq_info: {
          uint64_roaming_seq: seq,
          uint32_direction: 1, // 漫游消息方向 1:从seq往前拉取 2:从seq往后拉取
          uint32_size: size, // 漫游消息条数
          uint64_begin_time: 0, // 漫游起始时间
          uint64_end_time: 0, // 漫游结束时间
        },
      },
    };
  }

  /**
   * 7. 漫游消息响应包
   * http://9.135.87.124/#api-cloudim-324017
   */
  function unpackMsgRoamingRsp(response) {
    const result = [];
    // msg_roaming_rsp 新webim漫游消息；webim_roaming_adapted_rsp 老wbeim漫游消息
    const msg_roaming_rsp = response.msg_roaming_rsp || response.webim_roaming_adapted_rsp || { rpt_msg_roaming_msg: [] };
    const rpt_msg_roaming_msg_array = msg_roaming_rsp.rpt_msg_roaming_msg || msg_roaming_rsp.rpt_msg_sync_msg || [];
    for (const rpt_msg_roaming_msg of rpt_msg_roaming_msg_array) {
      if (!rpt_msg_roaming_msg) {
        continue;
      }
      // const msg_package_head = rpt_msg_roaming_msg["msg_package_head"]; // 目前不用
      const { msg_msg_head } = rpt_msg_roaming_msg;

      const { uint32_status } = msg_msg_head; // 消息的状态. 0:消息能正常展示 1:消息被撤回

      // const { uint64_random } = msg_msg_head; // 发送消息uuid
      const { uint64_msg_roaming_seq } = msg_msg_head; // 漫游消息seq

      const { uint64_msg_time } = msg_msg_head; // svr校正返回的时间

      const msg_third_app_info = msg_msg_head.msg_third_app_info || { bytes_third_app_buf: { bytes_crm_buf: '' } };
      const { bytes_third_app_buf } = msg_third_app_info;
      const { bytes_crm_buf } = bytes_third_app_buf;

      const { msg_type_info } = msg_msg_head;
      const { msg_c2c_info } = msg_type_info;
      const { uint64_from_aid } = msg_c2c_info; // 消息发送方
      const { uint64_to_aid } = msg_c2c_info; // 消息接受方

      const msg_msg_body = rpt_msg_roaming_msg.msg_msg_body || { rich_text: '' };
      const { rich_text } = msg_msg_body;
      if (bytes_crm_buf && bytes_crm_buf['msg_common_audio_video']) {
        // webRTC实时音视频消息
        let rtc_msg = unpackMsgRTCMsg(bytes_crm_buf['msg_common_audio_video']);
        result.push({
            type: 'rtc_msg',
            seq: uint64_msg_roaming_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            content: rtc_msg
        })
      } else if (rich_text && !(bytes_crm_buf && bytes_crm_buf.crm_flag === 55)) {
        // 为了完成这个需求做的特殊策略https://iwiki.woa.com/pages/viewpage.action?pageId=4007964350
        // 但crm_flag为55时，强制忽略rich_text中的值。
        // 这是因为rich_text存放的是给其他通路使用的数据，webim和小程序插件使用crm中的值。
        const elems = rich_text.elems || [];
        const array = [];
        for (const elem of elems) {
          if (!elem) continue;
          if (elem.text) {
            array.push({
              type: 'text',
              content: elem.text.str,
            });
          } else if (elem.face) {
            array.push({
              type: 'face',
              index: elem.face.uint32_index, // 表情索引号
              content: elem.face.bytes_default_text || '[自定义表情]',
            });
          } else if (elem.media_resources) {
            array.push({
              type: 'media_resources',
              meida_type: elem.media_resources.int32_meida_type,
              media_url: elem.media_resources.bytes_media_url,
              content: elem.media_resources.bytes_media_url,
            });
          } else if (elem.image) {
            array.push({
              type: 'image',
              uuid: elem.image.bytes_uuid,
              content: elem.image.bytes_image_path,
              md5: elem.image.bytes_image_md5,
              name: elem.image.bytes_image_name,
              size: elem.image.uint32_image_size,
              width: elem.image.uint32_image_width,
              height: elem.image.uint32_image_height,
              format: elem.image.uint32_image_format,
              resStore: elem.image.uint32_res_store,
              cosBucket: elem.image.uint32_cos_bucket,
            });
          } else if (elem.long_msg) {
            array.push({
              type: 'long_msg',
              content: elem.long_msg.bytes_longmsg_path,
              uuid: elem.long_msg.bytes_uuid,
              resStore: elem.long_msg.uint32_res_store,
              compressed: elem.long_msg.uint32_compress_type,
              cosBucket: elem.long_msg.uint32_cos_bucket,
            });
          } else if (elem.structured_info) {
            const sinfo = elem.structured_info;
            if (sinfo.uint32_format_flag === 1) { // 通用结构化消息，同 flag=14的情况
              array.push({
                type: 'qdxml_msg',
                content: {
                  uuid: sinfo.bytes_uuid,
                  path: sinfo.bytes_structure_path,
                  brief: sinfo.str_msg_brief,
                  content: sinfo.bytes_structure_content,
                  resStore: sinfo.uint32_res_store,
                  compressed: sinfo.uint32_structure_compress_type,
                  cosBucket: sinfo.uint32_cos_bucket,
                }
              
              });
            } else if (sinfo.uint32_format_flag === 2) {
              array.push({
                type: 'image_text',
                uuid: sinfo.bytes_uuid,
                path: sinfo.bytes_structure_path,
                content: sinfo.bytes_structure_content,
                format: sinfo.uint32_format_flag,
              });
            } else {
              _log('structured_info uint32_format_flag error!', sinfo.uint32_format_flag);
            }
          } else if (elem.file_info) {
            array.push({
              type: 'file_info',
              uuid: elem.file_info.bytes_uuid,
              // 兼容老webim漫游消息，使用uuid
              content: elem.file_info.bytes_file_path || elem.file_info.bytes_uuid,
              md5: elem.file_info.bytes_file_md5,
              name: elem.file_info.bytes_file_name,
              size: elem.file_info.uint32_file_size,
              format: elem.file_info.bytes_file_format,
              cosBucket: elem.file_info.uint32_cos_bucket,
            });
          } else if (elem.ptt_info) {
            array.push({
              type: 'ptt_info',
              uuid: elem.ptt_info.bytes_uuid,
              content: elem.ptt_info.bytes_ptt_path,
              md5: elem.ptt_info.bytes_ptt_md5,
              length: elem.ptt_info.uint32_ptt_length,
              size: elem.ptt_info.uint32_ptt_size,
              format: elem.ptt_info.uint32_format,
              cosBucket: elem.ptt_info.uint32_cos_bucket,
            });
          } else {
            array.push({
              type: 'text',
              content: '[未知消息类型]',
            });
          }
        }
        if (array.length === 1) {
          result.push({
            seq: uint64_msg_roaming_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            revoke: uint32_status,
            ...array[0],
            crm: bytes_crm_buf,
            msgHead: msg_msg_head,
            msgBody: msg_msg_body,
          });
        } else if (array.length > 1) {
          result.push({
            type: 'mix',
            seq: uint64_msg_roaming_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            revoke: uint32_status,
            content: array,
            crm: bytes_crm_buf,
            msgHead: msg_msg_head,
            msgBody: msg_msg_body,
          });
        }
      } else {
        if (bytes_crm_buf && bytes_crm_buf.crm_flag) {
          const {
            crm_flag: crmFlag,
            template_message: templateMsg,
            msg_common_control_msg_info: commonInfo,
            msg_third_party_msg_info: thirdInfo
          } = bytes_crm_buf;

          if (crmFlag === 14 && commonInfo) {
            let content = {
              path: commonInfo.str_control_msg_resid,
              brief: commonInfo.str_msg_brief,
              content: commonInfo.bytes_structure_content,
              resStore: commonInfo.uint32_res_store,
              compressed: commonInfo.uint32_structure_compress_type,
              cosBucket: commonInfo.uint32_cos_bucket,
            };

            result.push({
              type: 'qdxml_msg',
              seq: uint64_msg_roaming_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content,
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 55 && templateMsg) {
            // 机器人html消息
            const { bytes_content, uint32_type } = templateMsg;
            // 13 为机器人表单收集，直接扔掉历史消息中的此种消息
            if(uint32_type !== 13){
              result.push({
                type: 'robot',
                seq: uint64_msg_roaming_seq,
                time: uint64_msg_time / 1000,
                from: uint64_from_aid,
                to: uint64_to_aid,
                content: JSON.parse(bytes_content),
                crm: bytes_crm_buf,
                msgHead: msg_msg_head,
                msgBody: msg_msg_body,
              });
            }
          } else if (crmFlag === 115 && commonInfo) {
            // 机器人导航
            result.push({
              type: 'robot_nav',
              seq: uint64_msg_roaming_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: {
                path: commonInfo.str_control_msg_resid,
                content: commonInfo.bytes_structure_content,
                resStore: commonInfo.uint32_res_store,
                compressed: commonInfo.uint32_structure_compress_type,
                cosBucket: commonInfo.uint32_cos_bucket,
              },
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 56 && commonInfo) {
            // sdk-机器人消息，先和普通机器人消息（crm_flag=55）一样处理
            const { bytes_structure_content, uint32_type } = commonInfo;
            // 13 为机器人表单收集，直接扔掉历史消息中的此种消息
            if(uint32_type !== 13){
              result.push({
                type: 'robot',
                seq: uint64_msg_roaming_seq,
                time: uint64_msg_time / 1000,
                from: uint64_from_aid,
                to: uint64_to_aid,
                content: JSON.parse(bytes_structure_content),
                crm: bytes_crm_buf,
                msgHead: msg_msg_head,
                msgBody: msg_msg_body,
              });
            }
          } else if (thirdInfo && crmFlag) {
            // 未命中其他规则，则统一处理为 third_msg
            result.push({
              type: 'third_msg',
              seq: uint64_msg_roaming_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: {
                crmFlag,
                path: thirdInfo.string_res_id,
                brief: thirdInfo.string_msg_brief,
                content: thirdInfo.string_msg_content,
                resStore: thirdInfo.uint32_res_store,
              },
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          } else if (crmFlag === 11) {
            const gray_msg = unpackMsgGrayMsg(bytes_crm_buf);
            result.push({
              type: 'gray_msg',
              seq: uint64_msg_roaming_seq,
              time: uint64_msg_time / 1000,
              from: uint64_from_aid,
              to: uint64_to_aid,
              content: gray_msg,
              crm: bytes_crm_buf,
              msgHead: msg_msg_head,
              msgBody: msg_msg_body,
            });
          }
        } else {
          // 兜底逻辑
          result.push({
            seq: uint64_msg_roaming_seq,
            time: uint64_msg_time / 1000,
            from: uint64_from_aid,
            to: uint64_to_aid,
            content: null,
          });
        }
      }
    }

    return result;
  }

  /**
   * 8. 全部未读消息请求包(登陆时调用)
   * http://9.135.87.124/#api-cloudim-324018
   */
  function createMsgContactReq(context, offset, limit) {
    return {
      get_msg_contact_req: {
        str_data_context: context,
        uint32_offset: offset,
        uint32_limit: limit,
        uint32_type: 1 // 1:只请求有未读计数
      },
    };
  }

  /**
   * 9. 全部未读消息响应包
   * http://9.135.87.124/#api-cloudim-324018
   */
  function unpackMsgContactRsp(response) {
    let result = [];
    const get_msg_contact_rsp = response["get_msg_contact_rsp"] || { "str_data_context": '', "uint64_max_sync_seq": 0, "msg_recent_contact_info":[]};
    const str_data_context = get_msg_contact_rsp["str_data_context"];
    const uint64_max_sync_seq = get_msg_contact_rsp["uint64_max_sync_seq"]; // 最大同步id
    const msg_recent_contact_info_array = get_msg_contact_rsp["msg_recent_contact_info"] || [];
    for (const msg_recent_contact_info of msg_recent_contact_info_array) {
        if (!msg_recent_contact_info) { continue; }
        const contact_id_info = msg_recent_contact_info["contact_id_info"];
        const uint32_type = contact_id_info["uint32_type"]; // 号码类型 0:单聊 1:B客服号 2:imsdk号 3:群聊
        const uint64_contact_id = contact_id_info["uint64_contact_id"];

        const extend_info = msg_recent_contact_info["extend_info"] || {};
        const str_session_id = extend_info["str_session_id"] || '';
        const str_user_id = extend_info["str_user_id"] || '';
        const uint64_pubacc_id = extend_info["uint64_pubacc_id"] || 0;
        let user_type = extend_info["user_type"] || 0;

      if (user_type === 3) {
        /**
               * svr对于webim的定义是3
               * 前端对于webim的定义是4
               */
        user_type = proto.config.channelType;
      } else if (user_type === 1) {
        /**
               * svr对于微信公众号的定义是1
               * 前端对于微信公众号的定义是2
               */
        user_type = 2;
      } else if (user_type === 11) {
        /**
               * svr对于微信小程序的定义是11
               * 前端对于微信小程序的定义是6
               */
        user_type = 6;
      }

        const str_msg_summary = msg_recent_contact_info["str_msg_summary"]; // 消息摘要
        const uint32_unread_cnt = msg_recent_contact_info["uint32_unread_cnt"]; // 未读数
        const uint64_msg_unique_seq = msg_recent_contact_info["uint64_msg_unique_seq"]; // 最大漫游消息id
        const uint64_msg_sync_seq = msg_recent_contact_info["uint64_msg_sync_seq"]; // 最大同步消息id
        const uint32_block_status = msg_recent_contact_info["uint32_block_status"]; // 屏蔽状态
        const uint32_top_status = msg_recent_contact_info["uint32_top_status"]; // 置顶状态
        const uint64_top_time = msg_recent_contact_info["uint64_top_time"]; // 置顶时间
        const uint64_msg_time = msg_recent_contact_info["uint64_msg_time"]; // 发送时间

        result.push({
            // context: str_data_context,
            id: uint64_contact_id,
            type: uint32_type,
            summary: str_msg_summary,
            seq: uint64_msg_unique_seq,
            syncseq: uint64_msg_sync_seq,
            unread: uint32_unread_cnt,
            msgtime: uint64_msg_time / 1000,
            block: uint32_block_status,
            top: uint32_top_status,
            toptime: uint64_top_time / 1000,
            extend: {
                str_session_id: str_session_id,
                str_user_id: str_user_id,
                user_type: user_type,
                uint64_pubacc_id: uint64_pubacc_id
            }
        })
    }

    return {
        str_data_context: str_data_context,
        uint64_max_sync_seq: uint64_max_sync_seq,
        contact: result
    };
  }

  /**
   * 10. 已读消息请求包
   * http://9.135.87.124/#api-cloudim-324025
   */
  function createMsgReadReq(contact, type, seq) {
    return {
      msg_read_report_req: {
        msg_read_report_info: [{
          uint64_msg_roaming_seq: seq,
          contact_id_info: {
            uint32_type: type,
            uint64_contact_id: contact,
          },
        }],
      },
    };
  }

  /**
   * 11. 已读消息响应包
   * http://9.135.87.124/#api-cloudim-324025
   */
  function unpackMsgReadRsp(response) {
    const result = [];
    const msg_read_report_rsp = response.msg_read_report_rsp || { failed_msg_read_report_info: [] };
    const failed_msg_read_report_info_array = msg_read_report_rsp.failed_msg_read_report_info || [];
    for (const failed_msg_read_report_info of failed_msg_read_report_info_array) {
      if (!failed_msg_read_report_info) {
        continue;
      }
      const { uint64_msg_roaming_seq } = failed_msg_read_report_info;
      const { contact_id_info } = failed_msg_read_report_info;
      const { uint32_type } = contact_id_info;
      const uint64_contact_id = contact_id_info.contact_id_info;

      result.push({
        seq: uint64_msg_roaming_seq,
        id: uint64_contact_id,
        type: uint32_type,
      });
    }
    return result;
  }

  /**
   * 12. 获取文件上传接口/下载地址请求包
   * http://9.135.87.124/#api-cloudim-324030
   */
  function createMsgPreSignedUrlReq(method, resid, size, type, name, cosBucket) {
    const http_message = {
      uint32_http_method: method, // 2为上传 3为下载
    };
    if (method !== 3) {
      // 下载时不传这个值
      http_message.bytes_header_content_type = 'application/octet-stream'; // 写死
    }

    return {
      generate_presigned_url_req: {
        uint32_business_type: 10,
        http_message,
        obj_message: {
          bytes_obj_resid: resid,
          uint64_obj_size: size,
          uint32_obj_type: type,
          bytes_obj_name: encodeURIComponent(name),
        },
        uint32_cos_bucket: typeof(cosBucket)!=='undefined'? cosBucket : 0, // saas-imsdk 固定值1， 默认0。
      },
    };
  }

  /**
   * 13. 获取文件上传接口/下载地址响应包
   * http://9.135.87.124/#api-cloudim-324030
   */
  function unpackMsgPreSignedUrlRsp(response) {
    const { generate_presigned_url_rsp } = response;
    const { http_message } = generate_presigned_url_rsp;
    const { uint32_http_method } = http_message;
    // const bytes_header_content_type = http_message["bytes_header_content_type"];

    const { bytes_uuid } = generate_presigned_url_rsp;
    const { bytes_host } = generate_presigned_url_rsp;
    const { bytes_presigned_url } = generate_presigned_url_rsp;

    // post 方式上传时，无法根据get签名进行验证，只能单独返回post签名所需的参数，自行拼接在表单中
    const { post_cos_sign_info = null } = generate_presigned_url_rsp;

    return {
      method: uint32_http_method,
      host: bytes_host,
      url: bytes_presigned_url,
      uuid: bytes_uuid,
      postSignInfo: post_cos_sign_info,
    };
  }

  /**
   * 14. 消息撤回请求包
   * 消息撤回响应与"2. 消息发送响应包"一样
   */
  function createMsgRevokeReq(term, from, to, revoke,config) {
    return {
      msg_send_req: {
        msg_send_msg: {
          msg_package_head: {
            uint32_pkg_num: 1,
            uint32_pkg_index: 0,
            uint32_div_seq: 1,
          },
          msg_msg_head: createMsgSendHead(term, from, to, 1,config),
          msg_msg_body: {
            revoke_message: {
              uint64_msg_roaming_seq: revoke.uint64_msg_roaming_seq,
              uint64_msg_time: revoke.uint64_msg_time,
              uint64_msg_sync_seq: revoke.uint64_msg_sync_seq,
              uint64_side_sync_seq: revoke.uint64_side_sync_seq,
            },
          },
        },
      },
    };
  }

  /**
   * 高精度时间（High Resolution Time，简称hr-time）规范定义了Performance对象，
   * 通过Performance对象我们可以获得高精度的时间。
   *
   * ECMA-262 规范中定义了 Date 对象来表示自 1970 年 1 月 1 日以来的毫秒数。
   * 它足以满足大部分需求，但缺点是时间会受到时钟偏差与系统时钟调整的影响。
   * 时间的值不总是单调递增，后续值有可能会减少或者保持不变。
   *
   * https://zhuanlan.zhihu.com/p/43980238
   * https://zhuanlan.zhihu.com/p/65065472
   *
   * @returns {number}
   */
  function createMessageUUID() {
    if (typeof(window) !== 'undefined') {
      const performance = window.performance
        || window.msPerformance
        || window.webkitPerformance;
      if (performance && performance.timeOrigin) {
        const time = performance.timeOrigin + performance.now(); // performance.timeOrigin是一系列时间点的基准点，精确到万分之一毫秒
        return time * 10000 + Math.floor(Math.random() * 10000);
      } if (performance && performance.timing) {
        const time = performance.timing.navigationStart + performance.now();
        return time * 10000 + Math.floor(Math.random() * 10000);
      }
    }
    return Date.now() * 10000 + Math.floor(Math.random() * 10000);
  }

  /**
   * 创建企点要求的消息唯一id
   * fromid_toId_时间毫秒_随机数
   */
  function createQidianMsgUniqueId(fromId, toId) {
    return `${fromId}_${toId}_${Date.now()}_${createMessageUUID()}`
  }

  /**
   * 灰条消息解析
   *
   * @returns {Object}
   */
  function unpackMsgGrayMsg(bytes_crm_buf) {
    let string_text = '[未知消息类型]';
    let track_info = '';
    // const { crm_flag } = bytes_crm_buf;
    const { msg_gray_msg, msg_webim_extra_data, crm_alloc_kfext } = bytes_crm_buf; // 新灰条消息
    console.log(bytes_crm_buf, 'unpackMsgGrayMsg');
    const { msg_linktext_with_open_chat_msg_notify } = bytes_crm_buf; // 链接消息
    if (msg_gray_msg) {
      // 互动轨迹信息
      const msg_track_info = msg_gray_msg.msg_track_info || '';
      if (msg_track_info) {
        track_info = {
          c_id: msg_track_info.str_c_id, // 通路id
          // c_type: msg_track_info['uint32_c_type'],// 通路类型
          session_id: msg_track_info.str_session_id, // 会话id
          session_type: msg_track_info.uint32_session_type, // 会话类型 1:消息轨迹 2:互动轨迹 3:机器人轨迹
          begin_time: msg_track_info.uint64_begin_time,
          end_time: msg_track_info.uint64_end_time,
        };
      }
      // 系统通知消息(俗称小灰条)
      // 分为复杂场景和简单场景，先判断简单场景是否存在
      if (msg_gray_msg.str_text) {
        string_text = msg_gray_msg.str_text;
      } else {
        const rpt_msg_str_text_array = msg_gray_msg.rpt_msg_str_text || [];
        for (const rpt_msg_str_text of rpt_msg_str_text_array) {
          const { str_i18n_key } = rpt_msg_str_text; // 国际化本地文案映射中key值
          string_text = rpt_msg_str_text.string_text;
          // if (str_i18n_key === 'gray_msg.GRAY_MSG_MANUALLY_TRANSFER_B2') {
          //   const rpt_msg_param_array = rpt_msg_str_text.rpt_msg_param;
          //   string_text = 'b1_name向你转接了客户，会话开始\r\n附言：b1_attach_msg';
          //   for (const rpt_msg_param of rpt_msg_param_array) {
          //     string_text = string_text.replace(rpt_msg_param.str_param_name, rpt_msg_param.str_param_value);
          //   }
          // } else if (str_i18n_key === 'gray_msg.GRAY_MSG_MANUALLY_TRANSFER_B2_SWITCH_TIPS') {
          //   const rpt_msg_param_array = rpt_msg_str_text.rpt_msg_param;
          //   string_text = 'b1_name向你转接了客户，会话开始';
          //   for (const rpt_msg_param of rpt_msg_param_array) {
          //     string_text = string_text.replace(rpt_msg_param.str_param_name, rpt_msg_param.str_param_value);
          //   }
          // } else if (str_i18n_key === 'gray_msg.GRAY_MSG_AUTO_TRANSFER_B2') {
          //   string_text = '系统为你分配了超时未接待客户，会话开始';
          // }
        }
      }
    } else if (crm_alloc_kfext) {
      string_text = crm_alloc_kfext.crm_msg;
    } else if (msg_linktext_with_open_chat_msg_notify) {
      string_text = msg_linktext_with_open_chat_msg_notify.string_tips;
    }

    return {
      gray: string_text,
      track: track_info,
      msg_webim_extra_data
    };
  }

  /**
   * webRTC实时音视频消息解析
   *
   * @returns {Object}
   */
  function unpackMsgRTCMsg(msg_common_audio_video) {
    const str_i18n_key = msg_common_audio_video['str_i18n_key'];
    const uint32_roomid = msg_common_audio_video['uint32_roomid'];
    const uint64_msgtime = msg_common_audio_video['uint64_msgtime'];

    const str_text_msg = msg_common_audio_video['str_text_msg'] || '[未知消息内容]';
    const uint32_call_type = msg_common_audio_video['uint32_call_type'];
    const uint32_video_state = msg_common_audio_video['uint32_video_state'];
    const uint32_video_status_type = msg_common_audio_video['uint32_video_status_type'];
    return {
        str_text_msg: str_text_msg, // 上屏消息的文字内容
        uint32_call_type: uint32_call_type, // 通话类型：1视频，2音频
        uint32_video_state: uint32_video_state, // 录制状态 0.通话中 1.已录制但上传中 2.已录制且上传完 3.录制失败 4.不合法 5.已拒绝 6.未接听 7.已取消
        uint32_video_status_type: uint32_video_status_type // 会话状态 1.通话中(绿色) 2.通话时长(黑色) 3.其他(红色)
    }
  }


// ------------------------------------------------- 分隔线 -------------------------------------------------
  /**
   * 以下是export模块定义
   */
  const proto = {
    config: {
      kfuin: 0,
      from: 0,
      term: 0,
      wpaId: 0,
      channelType: 50,
    },
  };
  /**
   *
   * @param {Object} config - 协议全局配置
   * @param {number} config.kfuin - 消息发送方主号
   * @param {number} config.from - 消息发送方
   * @param {number} config.term - 消息发送终端类型
   */
  proto.initial = function (config) {
    this.config.kfuin = config.kfuin;
    this.config.from = config.from;
    this.config.term = config.term;
    this.config.wpaId = config.wpaId;
    this.config.channelType = config.channelType;
    this.config.cosBucket = config.cosBucket;
  };
  /**
   * 文本消息发送
   */
  proto.createTextMessage = function (to, text, crmData) {
    const textElems = [];
    for (const elem of text) {
      if (elem.type === 'text') {
        textElems.push({
          text: {
            str: elem.content || '',
          },
        });
      } else if (elem.type === 'media_resources') {
        textElems.push({
          media_resources: {
            int32_meida_type: elem.mediaType || 0,
            bytes_media_url: elem.mediaUrl || '',
          },
        });
      } else if (elem.type === 'face') {
        textElems.push({
          face: {
            uint32_index: elem.index,
            bytes_default_text: elem.content || ''
          },
        });
      }
    }
    const message = createMsgSendReq(this.config.term, this.config.from, to, textElems, this.config, crmData);
    return message;
  };
  /**
   * 图片消息发送
   */
  proto.createImageMessage = function (to, image) {
    const imageElems = [{
      image: {
        bytes_uuid: image.uuid || '',
        bytes_image_path: image.path || '',
        bytes_image_md5: image.md5 || '',
        bytes_image_name: image.name || '',
        uint32_image_size: image.size || 0,
        uint32_image_width: image.width || 0,
        uint32_image_height: image.height || 0,
        uint32_image_format: image.format || 0,
        uint32_cos_bucket: this.config.cosBucket || 0,
      },
    }];
    const message = createMsgSendReq(this.config.term, this.config.from, to, imageElems, this.config);
    return message;
  };
  /**
   *
   * 图文消息发送
   */
  proto.createImageTextMessage = function (to, imageText) {
    const structuredElems = [{
      structured_info: {
        bytes_uuid: imageText.uuid || '',
        bytes_structure_path: imageText.path || '',
        uint32_format_flag: 2,
        bytes_structure_content: imageText.content || '',
        uint32_cos_bucket: this.config.cosBucket || 0,
      },
    }];
    // eslint-disable-next-line no-param-reassign
    to.uint32_msg_id = imageText.id;
    const message = createMsgSendReq(this.config.term, this.config.from, to, structuredElems, this.config);
    return message;
  };
  /**
   * 企点规范XML消息发送
   *
   */
  proto.createQDXMLMessage = function (to, qdXml, crmData) {
    const msg_common_control_msg_info = qdXml.msg_common_control_msg_info || {
      str_control_msg_resid: '',
      uint64_kfuin: this.config.kfuin,
      str_msg_brief: '',
    };
    const msg_third_party_msg_info = qdXml.msg_third_party_msg_info || {
      string_msg_brief: '',
      string_res_id: '',
    };
    const message = createCrmbufMsgSendReq(this.config.term, this.config.from, to, {
      crm_flag: 14,
      msg_common_control_msg_info: {
        str_control_msg_resid: msg_common_control_msg_info.str_control_msg_resid,
        uint64_kfuin: this.config.kfuin,
        str_msg_brief: msg_common_control_msg_info.str_msg_brief,
        bytes_structure_content: '',
        uint32_res_store: 1,
        uint32_cos_bucket: this.config.cosBucket || 0,
      },
      msg_third_party_msg_info: {
        string_msg_brief: msg_third_party_msg_info.string_msg_brief,
        string_res_id: msg_third_party_msg_info.string_res_id,
        string_msg_content: '',
        uint32_res_store: 1,
        uint32_cos_bucket: this.config.cosBucket || 0,
      },
      // 额外crm信息
      ...crmData,
    }, this.config);
    return message;
  };
  /**
   * 文件消息发送
   */
  proto.createFileMessage = function (to, file) {
    const fileElems = [{
      file_info: {
        bytes_uuid: file.uuid || '',
        bytes_file_path: file.path || '',
        bytes_file_md5: file.md5 || '',
        bytes_file_name: file.name || '',
        uint32_file_size: file.size || 0,
        bytes_file_format: file.format || '',
        uint32_cos_bucket: this.config.cosBucket || 0,
      },
    }];
    const message = createMsgSendReq(this.config.term, this.config.from, to, fileElems, this.config);
    return message;
  };
  /**
   * 语音消息发送
   */
  proto.createPttMessage = function (to, ptt) {
    const pttElems = [{
      ptt_info: {
        bytes_uuid: ptt.uuid || '',
        bytes_ptt_path: ptt.path || '',
        bytes_ptt_md5: ptt.md5 || '',
        uint32_ptt_length: ptt.length || 0,
        uint32_ptt_size: ptt.size || 0,
        uint32_format: ptt.format || 0, // 当前语音格式 0为amr
        uint32_cos_bucket: this.config.cosBucket || 0,
      },
    }];
    const message = createMsgSendReq(this.config.term, this.config.from, to, pttElems, this.config);
    return message;
  };
  /**
   * 长文本消息
   */
   proto.createLongTextMessage = function (to, longmsg, crmData) {
    const longElems = [{
      long_msg: {
        bytes_uuid: longmsg.uuid || '',
        bytes_longmsg_path: longmsg.path || '',
        bytes_longmsg_md5: longmsg.md5 || '',
        uint32_longmsg_length: longmsg.length || 0,
        uint32_cos_bucket: this.config.cosBucket || 0,
        uint32_compress_type: longmsg.compressType || 0,
        // 消息摘要，敏感词等功能需要
        bytes_longmsg_brief: longmsg.brief || '',
      },
    }];
    const message = createMsgSendReq(this.config.term, this.config.from, to, longElems, this.config, crmData);
    return message;
  };
  /**
   * 获取响应消息的信息,返回给上层
   * @param {Object} message - 消息响应组包
   * @returns {number}
   */
  proto.unpackMsgSendRsp = function (message) {
    return unpackMsgSendRsp(message);
  };

  proto.createSyncMessage = function (seq, size) {
    return createMsgSyncReq(this.config.from, seq, size);
  };

  proto.unpackMsgSyncRsp = function (message) {
    return unpackMsgSyncRsp(message);
  };

  proto.unpackNewMsgNotice = function (message) {
    return unpackNewMsgNotice(message);
  };

  proto.createMsgRoamingReq = function (to, seq, size) {
    return createMsgRoamingReq(this.config.from, to, seq, size);
  };

  proto.unpackMsgRoamingRsp = function (message) {
    return unpackMsgRoamingRsp(message);
  };

  proto.createMsgContactReq = function (context, offset, limit) {
    return createMsgContactReq(context, offset, limit);
  };

  proto.unpackMsgContactRsp = function (message) {
    return unpackMsgContactRsp(message);
  };

  proto.createMsgReadReq = function (contact, type, seq) {
    return createMsgReadReq(contact, type, seq);
  };

  proto.unpackMsgReadRsp = function (message) {
    return unpackMsgReadRsp(message);
  };

  proto.createMsgUploadReq = function (type, size, name, usePost = false, resStore) {
    let cosBucket = this.config.cosBucket;
    // SDK特殊逻辑：uint32_res_store === 1 时， cosBucket的值应为0； resStore === 2时，cosBucket=0
    if (resStore === 1) {
      cosBucket = 0;
    }
    if (resStore === 2) {
      cosBucket = 1;
    }
    const resid = String(createMessageUUID());
    // 2为上传 3为下载。4为post方式上传
    return createMsgPreSignedUrlReq(usePost? 4 : 2, resid, size, type, name, cosBucket);
  };

  /**
   * 
   * @param {string} resid 资源id
   * @param {string} type 资源类型
   * @param {string} size 资源大小
   * @param {string} name 资源名称
   * @param {number} resStore 资源存储类型
   * @param {number} cosBucket 资源存储cos。文件下载时，不仅要根据整体的cosBucket配置，还要根据消息中的cosBucket进线双重判断。
   * 对于长文本、xml等，还要根据resStore进行判断
   * @returns 
   */
  proto.createMsgDownloadReq = function (resid, type, size, name, resStore, cosBucket) {
    let tmpCosBucket;

    // 优先使用消息中传入的cosBucket。
    if (typeof (cosBucket) !== 'undefined' && cosBucket !== null) {
      tmpCosBucket = cosBucket;
    }else if(typeof (resStore) !== 'undefined' && resStore !== null) {
      // SDK特殊逻辑：uint32_res_store === 1 时， tmpCosBucket的值应为0； resStore === 2时，tmpCosBucket=0
      if (resStore === 1) {
        tmpCosBucket = 0;
      }
      if (resStore === 2) {
        tmpCosBucket = 1;
      }
    }

    // 使用SDK统一配置的 cosBucket 兜底。
    if (typeof (tmpCosBucket) === 'undefined') {
      tmpCosBucket = this.config.cosBucket;
    }

    // 2为上传 3为下载
    return createMsgPreSignedUrlReq(3, resid, size, type, name, tmpCosBucket);
  };

  proto.unpackMsgUploadOrDownloadRsp = function (message) {
    return unpackMsgPreSignedUrlRsp(message);
  };

  proto.createRevokeMessage = function (to, message) {
    return createMsgRevokeReq(this.config.term, this.config.from, to, message,this.config);
  };

  // 进线
  proto.createMsgClientIncomingReq = function (message) {
    return {
      msg_handle_incoming_msq_req: {
        uint32_channel_type: message.channel_type || this.config.channelType, // wbeim 4
        uint64_kfuin: this.config.kfuin,
        bytes_openid: String(this.config.from),
        bytes_wpaid: this.config.wpaId,
        bytes_extra_content: message.extraContent || message.extra_content || '', // 兼容一下数据格式
        str_useragent: message.userAgent || ( typeof(navigator) !=='undefined' && navigator.userAgent ) || '',
        bytes_user_info: message.userInfo || '',
        custom_params: message.customParams || '',
        // uint64_qq: 0,
      },
    };
  };

  // 创建qd菜单消息（注：消息 interface 为 InnerImClickEventReq，这里取名有问题） 
  proto.createMsgQdmenuReq = function (message) {
    // 上报数据追加 wpaId.
    // why—— 机器人的各种逻辑需要 wpaId做一些相应操作，但是信令事件中并未携带该值，因此需要手动追加
    if (typeof(message.args) === 'string' && message.args.indexOf('wpaId') === -1) {
      message.args += `${message.args.indexOf('?') > -1? '&' : '?'}wpaId=${this.config.wpaId}`;
    }
    return {
      msg_inner_im_menu_event_req: {
        bytes_user_data: message.args,
        uint64_kfuin: this.config.kfuin,
        uint32_ctype: this.config.channelType,
        str_cid: String(this.config.from),
        bytes_content: message.text,
      }
    };
  };

  // C侧结束会话
  proto.createMsgCloseSessiongReq = function (message) {
    return {
      msg_customer_close_session_req: {
        uint32_session_type: this.config.channelType,
        uint64_kfuin: Number(this.config.kfuin),
        str_cid: String(this.config.from),  // 注意，这里写是是 str_c_id
      },
    };
  };

  // 拉取工号信息
  proto.createMsgGetCustomerDetailReq = function (message) {
    return {
      msg_inner_get_customer_detail_data_req: {
        uint64_kfuin: this.config.kfuin,
        uint64_kfext: Number(message.extuin),
        msg_customer_account: {
          uint32_contact_account_type: 2,
          bytes_account_value1: String(message.extuin),
        }
      }
    }
  }

  // 创建一个用于更新远端消息存储的消息体
  proto.createUpdateOnlineReq = function (message) {
    return {
      set_message_tag_req: {
        uint64_from_uin: message.from,
        uint64_to_uin: message.to,
        uint64_msg_roaming_id: message.roamingId,
        rpt_msg_tag: message.tags,
      },
    };
  };

  // 创建同步客户信息的消息体
  proto.createSetAidInfoReq = function (message) {
    return {
      set_aid_info_req: {
        uint64_aid: Number(this.config.from),
        msg_aid_info_data: { ...message },
      }
    }
  }

  // Saas 进线处理请求
  proto.createC2bSessionStartReq = function (message) {
    return {
      msg_c2b_session_start_req: {
        uint64_corpuin: Number(this.config.kfuin),
        str_c_id: String(message.cid),
        uint32_c_type: Number(this.config.channelType),
        msg_create_session_in: {
          uint32_strategy_type: Number(message.assignType),
          uint64_strategy_param: Number(message.assignId),
        },
      }
    }
  }

  /**
   * C侧发起满意度评价
   */
  proto.createActiveFeedbackReq = function (message) {
    return {
      msg_push_satisfaction_survey_all_channel_req: {
        uint32_channel: Number(this.config.channelType),
        uint32_send_type: 5, // 固定值，表示C侧手动触发。
        str_cid: String(message.cid),
      }
    }
  }

  /**
   * 被压缩长文本的下载
   */
  proto.createCompressedLongTextMsgDownloadReq = function (message, type) {
    const resStore = message.resStore;
    const cosBucket = message.cosBucket;

    let tmpCosBucket;

    // 优先使用消息中传入的cosBucket。
    if (typeof (cosBucket) !== 'undefined' && cosBucket !== null) {
      tmpCosBucket = cosBucket;
    }else if(typeof (resStore) !== 'undefined' && resStore !== null) {
      // SDK特殊逻辑：uint32_res_store === 1 时， tmpCosBucket的值应为0； resStore === 2时，tmpCosBucket=0
      if (resStore === 1) {
        tmpCosBucket = 0;
      }
      if (resStore === 2) {
        tmpCosBucket = 1;
      }
    }

    // 使用SDK统一配置的 cosBucket 兜底。
    if (typeof (tmpCosBucket) === 'undefined') {
      tmpCosBucket = this.config.cosBucket;
    }

    // 直接下载，前端不需要在发起ws请求来获取签名了。
    const data = {
      uint32_cloudim_appid: message.appid,
      uint64_kfuin: message.kfuin,
      cos_bucket: tmpCosBucket,
    };

    if (type === 'xml') {
      Object.assign(data, {
        uint32_msg_type: 1, // 文件类型：1-xml结构化消息；4-长文本
        struct_msg_info: {
          str_path: message.path, // 路径
          uint32_compress_type: message.compressed, // 压缩类型：0 不压缩， 1 gzip；
        },
      });
    } else {
      Object.assign(data, {
        uint32_msg_type: 4, // 文件类型：1-xml结构化消息；4-长文本
        long_msg_info: {
          str_path: message.path, // 路径
        },
      });
    }

    return data;
  }

  /**
   * 退出排队消息
   */
  proto.createExitQueueMessage = function (message) {
    const waitPoolUInfo = {
      uint32_type: 2, // 固定2
      str_cid: String(message.cid),
      // 用户排队信息，暂时不用传了。
    };
  
    const data = {
      uint64_kfuin: this.config.kfuin,
      uint32_delete_reason: 8, // 固定8
      rpt_msg_wait_pool_customer_info: [waitPoolUInfo],
    };

    return data;
  }

  /**
   * 请求老漫游数据接口
   * https://git.woa.com/qidian_platform/global_pb/merge_requests/1749
   */
  proto.createOldMsgRoamingReq = function (to, end, size) {
    return {
      // 注意，begin要求用于比end小，所以直接写0。
      webim_roaming_adapted_req: {
        uint64_begin_timestamp: 0, // 漫游起始时间,us级时间戳
        uint64_end_timestamp: end, // 漫游结束时间，us级时间戳
        uint32_size: size,
        uint32_direction: 1, // 漫游方向,1-从end_timestamp到begin_timestamp,2-从begin_stamp到end_timestamp
      },
    };
  };

  /**
   * 查询当前会话状态。
   */
  proto.createMsgSessionGetReq = function (message) {
    return {
      msg_session_get_req: {
        msg_head: {
          uint64_session_type: this.config.channelType,
          uint64_kfuin: this.config.kfuin,
          str_visitid: String(message.cid),
        },
        bool_only_assgin: false,
      }
    }
  }

  /**
   * 上报消息已被阅读 包
   * @param {*} params 
   */
  proto.createReportMsgReadReportReq = function (params) {
    return {
      report_msg_read_report_req: {
        int32_ctype: this.config.channelType,
        string_client_term_type: params.clientTermType, // // b, c。表示上报的是b侧还是c侧的已读状态
        string_cid: params.cid,
        string_seq_id: String(params.seq),
        uint64_time: params.time //最新已读消息的毫秒级时间戳，小于等于该时间的消息已读，大于该时间的消息未读
      }
    }
  };

  /**
   * 拉取消息已读状态 包
   * @param {*} params 
   */
  proto.createGetMsgReadInfoReq = function (params) {
    return {
      get_msg_read_report_req: {
        uint64_kfuin: Number(this.config.kfuin),
        int32_ctype: this.config.channelType,
        string_cid: params.cid,
      }
    }
  };

  return proto;
}

export default createProto;
